"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { localeForPath } from "@/lib/seo";

/**
 * Keeps `<html lang>` in step with the URL across client-side navigation.
 *
 * The root layout prints `lang="en"` for every route and LANG_BOOT_SCRIPT
 * corrects it on a hard load of a Dutch page — but the root layout never
 * re-renders on a client navigation, so without this a reader who followed a
 * link from /nl/voor-kopers to /for-expats would carry `lang="nl"` onto an
 * English page (and the reverse). The landing's LanguageProvider sets the same
 * value on its own pages; every one of them pins the language its route
 * implies, so the two can never disagree.
 */
export default function HtmlLangSync() {
  const pathname = usePathname();
  useEffect(() => {
    document.documentElement.lang = localeForPath(pathname ?? "/");
  }, [pathname]);
  return null;
}
